// extracted by mini-css-extract-plugin
module.exports = {"account":"index_account_9kNu5","icon":"index_icon_30VbY","number":"index_number_33YZp","sum":"index_sum_1I02P","footer":"index_footer_3-icA"};